import { Component, Input } from '@angular/core';

export type KtStepperStepState = 'pending' | 'active' | 'completed';

export interface KtStepperDetail {
  label?: string;
  labelKey?: string;
  value?: string;
  valueKey?: string;
  valueParams?: Record<string, string | number>;
}

export interface KtStepperStep {
  id: string;
  label?: string;
  labelKey?: string;
  stepNumber: number;
  state: KtStepperStepState;
  details?: KtStepperDetail[];
}

@Component({
  selector: 'kt-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
})
export class StepperComponent {
  @Input() steps: KtStepperStep[] = [];

  trackByStepId(_index: number, step: KtStepperStep): string {
    return step?.id || String(_index);
  }
}
